export default __webpack_public_path__ + "static/media/16.e167fd55.png";